import { Grid, SxProps, Theme } from "@mui/material";

type ScreenRootProps = {
  children: React.ReactNode;
  hasFooter?: boolean;
  sx?: SxProps<Theme>;
};

export function ScreenRoot({ children, hasFooter, sx }: ScreenRootProps) {
  return (
    <Grid
      container
      sx={{
        display: "flex",
        alignContent: hasFooter ? "none" : "flex-start",
        alignItems: "center",
        ...sx,
      }}
    >
      {children}
    </Grid>
  );
}
